<div class="mainDiv">
    <div class="newOrder" (mousedown)="onMouseDown($event)">
        <div style="width: 90%;text-align: center;">
            <!-- <h3>New Delivery!</h3> -->
        </div>

        <div style="width: 10%;">
            <mat-icon (click)="hide()" class="address_span"
                style="font-size: 22px !important;overflow: inherit;background: none;width: 100%;">highlight_off
            </mat-icon>
        </div>
    </div>

    <div>
        <div style="background: white; overflow: auto;">
            <div class="container" style="padding: 10px !important;">
                <agm-map [latitude]="latitude" [longitude]="longitude" style="height: 400px; width: 100%;">
                    <agm-direction [origin]="origin" [destination]="destination" [waypoints]="waypoints"
                        [renderOptions]="renderOptions" [markerOptions]="markerOptions">
                    </agm-direction>
                </agm-map>
            </div>
        </div>
    </div>
</div>